import { createFragmentContainer, graphql } from 'react-relay';
import EventOverviewComponent from './EventOverviewComponent';

export default createFragmentContainer(EventOverviewComponent, {
  node: graphql`
    fragment EventOverviewContainer_node on Event {
      id
      title
      workspaces(first: 99999) @connection(key: "EventOverviewContainer_workspaces")  {
        edges {
          node {
            id
            title
          }
        }
      }
    }
  `,
  viewer: graphql`
    fragment EventOverviewContainer_viewer on User {
      id
    }
  `
});



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/EventOverviewContainer.js